// src/lib/api.js
//
// Tiny fetch wrapper. Same-origin, sends cookies, normalizes errors.
// On 401 from a non-login endpoint we bounce to `/` — the lobby re-renders
// and can show a fresh lockout status.

export async function api(path, opts = {}) {
  const url = path.startsWith("/") ? path : `/${path}`;
  const res = await fetch(`/api${url}`, {
    credentials: "same-origin",
    ...opts,
    headers: {
      "content-type": "application/json",
      ...(opts.headers || {}),
    },
  });
  let body = null;
  try {
    body = await res.json();
  } catch {
    // not all endpoints return JSON
  }
  return { status: res.status, ok: res.ok, body };
}

// Convenience for POSTing JSON.
export async function postJson(path, data) {
  return api(path, {
    method: "POST",
    body: JSON.stringify(data),
  });
}
